import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const BorderedButton = ({ onClick, buttonText, borderColor, className, attributes }) => {
  return (
    <button
      className={classnames('classic btn', className, borderColor)}
      style={{ minWidth: 120 }}
      onClick={onClick}
      {...attributes}
    >
      {buttonText}
    </button>
  );
};

BorderedButton.propTypes = {
  onClick: PropTypes.func,
  buttonText: PropTypes.string,
  className: PropTypes.string,
  attributes: PropTypes.object,
  borderColor: PropTypes.string
};

export default BorderedButton;
